import { Colors, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

export interface AutosaveState {
    isPending: boolean;
    isSuccess: boolean;
    isError: boolean;
}

export interface AutosaveIndicatorProps {
    employeeId: string;
    autosave: AutosaveState;
}

/** Live region under a row's comment field, announcing where its autosave stands. */
export const AutosaveIndicator = ({ employeeId, autosave }: AutosaveIndicatorProps) => {
    const { t } = useAmelioTranslations();

    return (
        // Rendered at all times so the live region exists before its text changes: an aria-live
        // node inserted together with its content is often missed.
        <div
            role={'status'}
            aria-live={'polite'}
            data-testid={`calibration-save-status-${employeeId}`}
        >
            {autosave.isPending && (
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {t('calibration.table.saving')}
                </Text>
            )}

            {autosave.isSuccess && !autosave.isPending && (
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {t('calibration.table.saved')}
                </Text>
            )}

            {autosave.isError && (
                <Text
                    size={'small'}
                    color={Colors.ERROR}
                >
                    {t('calibration.table.error')}
                </Text>
            )}
        </div>
    );
};
